import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, formValueSelector } from 'redux-form'
import * as actions from '../../actions'
import { AnulacionEgreso0, AnulacionEgreso1 } from './steps'
import { FORM_ANULACION_EGRESO } from '../../../../config/forms'

import { INTERVALO_CORTO } from '../../../../config/settings'
import { ToastContainer } from 'react-toastify'

const selector = formValueSelector(FORM_ANULACION_EGRESO)

class AnulacionEgreso extends Component {
  constructor (props) {
    super(props)
    this.nextStep = this.nextStep.bind(this)
    this.prevStep = this.prevStep.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  nextStep () {
    const {
      verificarEgreso,
      anulacionEgresoStep,
      numero
    } = this.props

    if (anulacionEgresoStep === 0) {
      verificarEgreso(numero)
    }
  }

  prevStep () {
    this.props.anulacionEgresoPrevStep()
  }

  handleSubmit () {
    this.props.anularEgresoCalado(this.props.destroy)
  }

  render () {
    const {
      anulacionEgresoStep
    } = this.props

    return (
      <div className='camiones-anulacionIngreso-container'>
        <h2>Anulación de Egreso de Calado</h2>
        {anulacionEgresoStep === 0 && <AnulacionEgreso0 onSubmit={this.nextStep} />}
        {anulacionEgresoStep === 1 &&
          <AnulacionEgreso1 onSubmit={this.handleSubmit} onPrev={this.prevStep} />}
        <ToastContainer autoClose={INTERVALO_CORTO} />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    numero: selector(state, 'numero'),
    anulacionEgresoStep: state.calado.anulacionEgresoStep
  }
}

const withRedux = connect(mapStateToProps, actions)
export default withRedux(
  reduxForm({ form: FORM_ANULACION_EGRESO })(AnulacionEgreso)
)
